import {Component, HostBinding, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {User} from '../../model/user';
import {environment} from '../../../environments/environment';
import {Constants} from "../../utils/constants";
import {SnackService} from "../../services/snack.service";
import {FileSaverService} from "ngx-filesaver";
import {TestbedsService} from "../../services/testbeds.service";
import {OverlayContainer} from '@angular/cdk/overlay';

@Component({
  selector: 'aw-private-container',
  templateUrl: './private-container.component.html',
  styleUrls: ['./private-container.component.scss']
})
export class PrivateContainerComponent implements OnInit {
  loggedUser?: User;
  title: string;
  @HostBinding('class') className = '';
  darkTheme = false; // false = light, true = dark
  version = environment.appVersion;
  isChina: boolean;

  constructor(
    public router: Router,
    public testbedService: TestbedsService,
    public snackService: SnackService,
    public fileSaverService: FileSaverService,
    public authService: AuthService,
    private overlay: OverlayContainer) {
    this.title = environment.appName;
    this.isChina = environment.isChina;
    this.authService.onUserChange().subscribe(value => this.loggedUser = value);
  }

  ngOnInit(): void {
    const darkTheme = localStorage.getItem('darkTheme');
    this.darkTheme = darkTheme === 'true';
    this.setTheme();

  }

  isActive(partialUrl: string): boolean {
    return this.router.isActive(
      partialUrl,
      {
        paths: 'subset',
        fragment: 'ignored',
        matrixParams: 'ignored',
        queryParams: 'ignored'
      }
    );
  }

  logout(): void {
    this.authService.logout();
  }

  changeTheme(): void {
    this.darkTheme = !this.darkTheme;
    this.setTheme();
    localStorage.setItem('darkTheme', this.darkTheme ? 'true' : 'false');
  }

  private setTheme(): void {
    this.className = this.darkTheme ? Constants.styling.darkClassName : '';

    if (this.darkTheme) {
      this.overlay.getContainerElement().classList.add(Constants.styling.darkClassName);
    } else {
      this.overlay.getContainerElement().classList.remove(Constants.styling.darkClassName);
    }
  }


}
